import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteHeader } from "@/components/SiteHeader";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import TermDetail from "@/pages/TermDetail";
import TeacherLogin from "@/pages/TeacherLogin";
import TeacherDashboard from "@/pages/TeacherDashboard";
import Quiz from "@/pages/Quiz";
import PrintGlossary from "@/pages/PrintGlossary";
import Progress from "@/pages/Progress";
import Leaderboard from "@/pages/Leaderboard";
import StudySheetPrint from "@/pages/StudySheetPrint";
import MapWorksheet from "@/pages/MapWorksheet";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <SiteHeader />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/termine/:id" element={<TermDetail />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/stampa" element={<PrintGlossary />} />
          <Route path="/progressi" element={<Progress />} />
          <Route path="/classifica" element={<Leaderboard />} />
          <Route path="/scheda-mappa/:id" element={<MapWorksheet />} />
          <Route path="/docente/fogli/:id" element={<ProtectedRoute><StudySheetPrint /></ProtectedRoute>} />
          <Route path="/docente/login" element={<TeacherLogin />} />
          <Route path="/docente" element={<ProtectedRoute><TeacherDashboard /></ProtectedRoute>} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
